function initialState() {
  return ({
    orderRebuyId: null,
    buyerName: null,
    orderType: null,
    payment_info: null,
    shipping_info: null,
    payment_data: null
  });
}

export function orderRebuy(state = initialState(), action) {
  switch (action.type) {
    case 'SET_ORDER_REBUY':
      return { ...state, orderRebuyId: action.orderRebuyId };
    case 'SET_REBUY_INFO':
      return { ...state, buyerName: action.buyerName, orderType: action.orderType, payment_info: action.payment_info, shipping_info: action.shipping_info, payment_data: action.payment_data };
    case 'RESET_REBUY':
      return initialState();
    default:
      return state;
  }
}
